// extracted by mini-css-extract-plugin
export default {"calculate-soil":"calculate_calculate-soil__8nTSL","calculate-soil__inner":"calculate_calculate-soil__inner__Sd6V7"};